import { render } from "./EmailCardV2.vue?vue&type=template&id=42d1317e&scoped=true"
import script from "./EmailCardV2.vue?vue&type=script&lang=js"
export * from "./EmailCardV2.vue?vue&type=script&lang=js"

import "./EmailCardV2.vue?vue&type=style&index=0&id=42d1317e&lang=scss"
import "./EmailCardV2.vue?vue&type=style&index=1&id=42d1317e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d1317e"]])

export default __exports__